import { Grid, Row, RowProps } from 'antd';

const { useBreakpoint } = Grid;

export const DataRow = ({ children, justify }: { children: any; justify?: RowProps['justify'] }) => {
  const screens = useBreakpoint();

  return (
    <Row style={{ padding: 5, display: screens.md ? 'flex' : 'block' }} justify={justify}>
      {children}
    </Row>
  );
};
